export default __webpack_public_path__ + "static/media/112-person-white.65e04deb.svg";